import { AtlasHtml, AtlasPageHeaderProps } from 'atlas-ds';
import { BreadcrumbProps } from 'components/breadcrumb';
import Template from 'template';

interface TextChildren {
    title?: string
    breadcrumb?: BreadcrumbProps
    pageHeader: React.ReactElement<AtlasPageHeaderProps>;
    children: JSX.Element | JSX.Element[]
}

export default function Text(props: TextChildren) {
    return <Template hideSearch={ true } pageHeader={props.pageHeader}>
        <AtlasHtml>
            { props.children }
        </AtlasHtml>
    </Template>
}
